import locationService from 'shared/services/api/location/locationService';
import { AsyncAction } from 'shared/types/utilities';

import { GetCountries, SetCountries } from 'store/location/location.types';
import { ActionType } from 'store/types';

// ============================== Redux Actions =======================================================================

export const setCountries: SetCountries = (countries) => ({
  type: ActionType.SetCountries,
  payload: countries,
});

export const getCountries: AsyncAction<GetCountries> = (locale: string) => async (dispatch) => {
  const countries = await locationService.getCountries(locale);

  dispatch(setCountries(countries));
};
